<main>
  <colimo-sidenav></colimo-sidenav>
  <colimo-error></colimo-error>
</main>
